import { isAxiosError, isFieldError } from '@wkda/funnel-utils';
import { LIMIT_ERROR_MESSAGE } from './axiosDefaults';
import { getHeaderCaseInsensitive } from './getHeaderCaseInsensitive';
export class ApiError extends Error {
  url;
  status;
  traceId;
  method;
  constructor(error) {
    super(ApiError.constructErrorMessage(error));
    this.name = 'ApiError';
    this.url = `${error.config?.baseURL}${error.config?.url}`;
    this.status = error.response?.status;
    this.method = error.config?.method?.toUpperCase();
    this.traceId = getHeaderCaseInsensitive(error.response?.headers || {}, 'X-B3-Traceid');
  }
  static constructErrorMessage(error) {
    let errorMessage = '';
    if (isAxiosError(error)) {
      errorMessage += `${error.message} `;
      if (isFieldError(error)) {
        const {
          globalErrors,
          fieldErrors
        } = error.response?.data || {};
        if (globalErrors && globalErrors.length > 0) errorMessage += `\n${globalErrors.join('; ')}`;
        if (fieldErrors && fieldErrors.length > 0) {
          errorMessage += `\n${fieldErrors.map(e => e.message).join('; ')}`;
        }
      } else {
        if (typeof error.response?.data === 'object') {
          errorMessage += JSON.stringify(error.response?.data);
        } else if (typeof error.response?.data === 'string') {
          errorMessage += error.response?.data;
        }
      }
    } else {
      errorMessage += 'Unknown error';
    }

    // Limit to 1000 characters to ensure compatibility with Kibana.
    return errorMessage.length > LIMIT_ERROR_MESSAGE - 3 ? `${errorMessage.substring(0, LIMIT_ERROR_MESSAGE - 3)}...` : errorMessage;
  }
}